import { WebPlayer, WithStatsForNerdsWebRenderer, getDeviceCapabilities, getWebAdapters, WebAdapterName, } from '@zattoo/playback-sdk';
import { PlayerWithLive } from '../stream/live';
import { PlayerWithZapiBase } from './base';
import { PlayerWithVod } from '../stream/vod';
import { PlayerWithRecording } from '../stream/recordings';
import { PlayerWithReplay } from '../stream/replay';
import { PlayerWithStreamRequest } from '../stream/request';
import { updateDeviceCapabilities, getWebDeviceCapabilities, } from '../capability';
export const WithZapi = (Base) => {
    return PlayerWithReplay(PlayerWithRecording(PlayerWithVod(PlayerWithLive(PlayerWithStreamRequest(PlayerWithZapiBase(Base))))));
};
const WebPlayerZapi = WithZapi(WithStatsForNerdsWebRenderer(WebPlayer));
export const createPlayer = async (options) => {
    updateDeviceCapabilities(getWebDeviceCapabilities());
    const playerAdapterName = options.playerAdapter ?? WebAdapterName.Shaka;
    const PlayerAdapter = await getWebAdapters()[playerAdapterName]();
    const player = new WebPlayerZapi(options, new PlayerAdapter.AdapterWithIma(options, getDeviceCapabilities));
    return Promise.resolve(player);
};
